
document.addEventListener('DOMContentLoaded', function () {
  const badge = document.querySelector('span.badge.price-badge-sale');
  const priceRegular = document.querySelector('.price__regular');

  if (badge && priceRegular) {
    priceRegular.appendChild(badge);
    console.log('[price-debug] Price badge has been appended');
  } else {
    console.log('[price-debug] Badge or price__regular not found');
  }

  function collectPriceDebugState(root) {
    if (!root) return null;

    const oldPriceEl = root.querySelector('.price__sale .price-item--regular, .price__regular .price-item--regular');
    const salePriceEl = root.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
    const saveBadgeEl = root.querySelector('.price__save-badge');

    return {
      classes: root.className,
      targetPrice: root.dataset.debugTargetPrice,
      targetCompareAt: root.dataset.debugTargetCompareAt,
      computedPrice: root.dataset.debugPrice,
      computedCompareAt: root.dataset.debugCompareAt,
      moneyPrice: root.dataset.debugMoneyPrice,
      available: root.dataset.debugAvailable,
      country: root.dataset.debugCountry,
      currency: root.dataset.debugCurrency,
      template: root.dataset.debugTemplate,
      renderedOldPriceText: oldPriceEl ? oldPriceEl.textContent.trim() : null,
      renderedSalePriceText: salePriceEl ? salePriceEl.textContent.trim() : null,
      renderedSaveBadgeText: saveBadgeEl ? saveBadgeEl.textContent.trim() : null,
      regularVisible: !!(root.querySelector('.price__regular') && getComputedStyle(root.querySelector('.price__regular')).display !== 'none'),
      saleVisible: !!(root.querySelector('.price__sale') && getComputedStyle(root.querySelector('.price__sale')).display !== 'none'),
    };
  }

  function logPriceDebug(label) {
    const roots = document.querySelectorAll('[data-debug-price-root="true"]');
    if (!roots.length) {
      console.log('[price-debug]', label, 'No price debug roots found');
      return;
    }

    roots.forEach((root, index) => {
      console.groupCollapsed(`[price-debug] ${label} #${index + 1}`);
      console.table(collectPriceDebugState(root));
      console.groupEnd();
    });
  }

  // Initial page load snapshot.
  logPriceDebug('DOMContentLoaded');

  // Variant switch in Dawn uses pub/sub (preferred), with DOM event fallback.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(function () {
        logPriceDebug('PUB_SUB_EVENTS.variantChange');
      }, 0);
    });
  } else {
    document.addEventListener('variant-change', function () {
      setTimeout(function () {
        logPriceDebug('variant-change');
      }, 0);
    });
  }

  // Helpful when market/currency switch causes a full rerender.
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      logPriceDebug('shopify:section:load');
    }, 0);
  });
});

